export const ORGANIZATION_SWITCH_ROUTE = '/organization-switch';

export const TICKETS_ROUTE = '/tickets';
export const TICKET_DETAILS_ROUTE = `${TICKETS_ROUTE}/:ticketId`;

export const DATA_EXPLORER_ROUTE = '/data-explorer';

export const EVENT_LOG_SEARCH_ROUTE = `${DATA_EXPLORER_ROUTE}/event-log/search`;

// Unified Content Library
export const UNIFIED_CONTENT_LIBRARY = '/unified-content-library';
export const UNIFIED_CONTENT_LIBRARY_CATALOG_SEARCH_ROUTE = `${UNIFIED_CONTENT_LIBRARY}/search`;
export const UNIFIED_CONTENT_LIBRARY_DETECTION_DETAIL_ROUTE = `${UNIFIED_CONTENT_LIBRARY}/detections`;

// Reports routes
export const REPORTS_ROUTE = '/reports';
export const REPORTS_DETAILS_ROUTE = '/reports/:reportId';
export const SCHEDULED_REPORTS_ROUTE = '/reports/scheduled';

export const INSIGHTS_ROUTE = `${REPORTS_ROUTE}/dashboards`;
export const INSIGHTS_DASHBOARD_ROUTE = `${INSIGHTS_ROUTE}/:dashboardId`;

// resource-center
export const RESOURCE_CENTER_ROUTE = '/resource-center';
export const RESOURCE_CENTER_DOWNLOADS_ROUTE = `${RESOURCE_CENTER_ROUTE}/downloads`;
export const ALLOW_LIST_REQUIREMENTS_ROUTE = `${RESOURCE_CENTER_ROUTE}/allow-list`;
export const CONTACT_CONCIERGE_ROUTE = `${RESOURCE_CENTER_ROUTE}/contact-concierge`;
export const CONTACT_CONCIERGE_SUCCESS_ROUTE = `${CONTACT_CONCIERGE_ROUTE}/success`; // TODO, this should not be a route but a state.

// Account Page Route
export const ACCOUNT_ROUTE = '/account';
export const ACCOUNT_CONTACTS_ROUTE = `${ACCOUNT_ROUTE}/contacts`;
export const ACCOUNT_CONTACT_DETAILS_ROUTE = `${ACCOUNT_CONTACTS_ROUTE}/:contactId`;
export const ACCOUNT_NEW_CONTACT = `${ACCOUNT_CONTACTS_ROUTE}/new-contact`;

export const ACCOUNT_ESCALATIONS_ROUTE = `${ACCOUNT_ROUTE}/escalations`;
export const ACCOUNT_ESCALATIONS_DETAILS_ROUTE = `${ACCOUNT_ROUTE}/escalations/:configId`;

export const ACCOUNT_INTEGRATIONS_ROUTE = `${ACCOUNT_ROUTE}/integrations`;

export const ACCOUNT_ITSM_INTEGRATIONS_ROUTE = `${ACCOUNT_INTEGRATIONS_ROUTE}/itsm`;
export const ACCOUNT_CONNECTWISE_INTEGRATION_ROUTE = `${ACCOUNT_ITSM_INTEGRATIONS_ROUTE}/connect-wise`;
export const ACCOUNT_CONNECTWISE_NEW_INTEGRATION_ROUTE = `${ACCOUNT_ITSM_INTEGRATIONS_ROUTE}/connect-wise/new`;
export const ACCOUNT_SERVICENOW_INTEGRATION_ROUTE = `${ACCOUNT_ITSM_INTEGRATIONS_ROUTE}/service-now`;
export const ACCOUNT_SERVICENOW_NEW_INTEGRATION_ROUTE = `${ACCOUNT_ITSM_INTEGRATIONS_ROUTE}/service-now/new`;

export const ACCOUNT_CONFIG_RULES_ROUTE = `${ACCOUNT_ROUTE}/configuration-rules`;
export const ACCOUNT_CONFIG_MANAGEMENT_ROUTE = `${ACCOUNT_CONFIG_RULES_ROUTE}/management`;
export const ACCOUNT_CONFIG_MANAGEMENT_REQUEST_ROUTE = `${ACCOUNT_CONFIG_RULES_ROUTE}/management/request`;
export const ACCOUNT_ALERT_CONFIG_RULE_ROUTE = `${ACCOUNT_CONFIG_RULES_ROUTE}/alerts/:alertId`;
export const ACCOUNT_SUPPRESSION_CONFIG_RULE_ROUTE = `${ACCOUNT_CONFIG_RULES_ROUTE}/suppressions/:suppressionId`;

export const ACCOUNT_CONFIG_FEDERATED_AUTHENTICATION = `${ACCOUNT_ROUTE}/federated-authentication`;
export const ACCOUNT_ONBOARDING_ROUTE = `${ACCOUNT_ROUTE}/onboarding`;

// Active Response
export const ACTIVE_RESPONSE = `${ACCOUNT_INTEGRATIONS_ROUTE}/active-response`;
export const ACTIVE_RESPONSE_NEW_INTEGRATION = `${ACTIVE_RESPONSE}/new`;
export const ACTIVE_RESPONSE_INSTANCE_VIEW = `${ACTIVE_RESPONSE}/view/:instanceId`;

export const ACCOUNT_SITES_ROUTE = `${ACCOUNT_ROUTE}/sites`;
export const ACCOUNT_VIEW_SITES_ROUTE = `${ACCOUNT_SITES_ROUTE}/view/:siteUUID`;
export const ACCOUNT_ADD_SITES_ROUTE = `${ACCOUNT_SITES_ROUTE}/add`;
export const ACCOUNT_SITES_DELETE_REQUEST_ROUTE = `${ACCOUNT_SITES_ROUTE}/request-deletion`;

// RAW LOG SEARCH ROUTES
export const LOG_SEARCH_ROUTE = `${DATA_EXPLORER_ROUTE}/raw-log/search`;
export const LOG_SEARCH_ROUTE_SINGLE_SEARCH = `${LOG_SEARCH_ROUTE}/:searchId`;
export const LOG_SEARCH_HISTORY_ROUTE = `${DATA_EXPLORER_ROUTE}/raw-log/history`;
export const LOG_SEARCH_SOURCES_ROUTE = `${DATA_EXPLORER_ROUTE}/raw-log/sources`;
export const LOG_SEARCH_DOWNLOAD_ROUTE = `${DATA_EXPLORER_ROUTE}/raw-log/download/:queryId/:outputId/:fileId`;

// DATA FLOW ROUTES
export const DATA_FLOW_ROUTE = `${DATA_EXPLORER_ROUTE}/flow`;
export const DATA_FLOW_TYPE_ROUTE = `${DATA_EXPLORER_ROUTE}/flow/:type`;

export const COVERAGE_SCORE_ROUTE = '/telemetry/coverage-score';

// ADS ROUTES
export const ADS_ROUTE_ASSETS = '/assets';
export const ADS_ROUTE_TAG_MANAGEMENT = `${ADS_ROUTE_ASSETS}/tags`;

// DETECTION CATALOG ROUTES
export const DETECTION_CATALOG_ROUTE = '/detection-catalog';
export const DETECTION_DETAILS = '/detection-catalog/:id';

// SECURITY JOURNEY ROUTES
export const SECURITY_JOURNEY_ROUTE = '/security-journey';
export const SECURITY_FOCUSES_ROUTE = '/security-journey/security-focuses';
export const SPIDR_LIBRARY_ROUTE = '/security-journey/spidr-library';

// TELEMETRY ROUTES
export const TELEMETRY_OVERVIEW_ROUTE = '/telemetry';
export const TELEMETRY_SENSORS_ROUTE = '/telemetry/sensors';
export const TELEMETRY_SENSORS_ADD_ROUTE = `${TELEMETRY_SENSORS_ROUTE}/add`;
export const TELEMETRY_SENSORS_VIEW_ROUTE = `${TELEMETRY_SENSORS_ROUTE}/view`;
export const TELEMETRY_SENSORS_ADD_REQUEST_ROUTE = `${TELEMETRY_SENSORS_ROUTE}/contact-concierge`;

export const TELEMETRY_SCANNERS_ROUTE = '/telemetry/scanners?sort=status';
export const TELEMETRY_SCANNERS_ADD_ROUTE = '/telemetry/scanners/add';
export const TELEMETRY_SCANNERS_CONFIG_ROUTE = '/telemetry/scanners/:scannerId';
export const TELEMETRY_AGENTS_ROUTE = '/telemetry/agents';
export const TELEMETRY_CLOUD_SENSORS_ROUTE = '/telemetry/cloud';
export const TELEMETRY_ADD_CLOUD_SENSORS_ROUTE = '/telemetry/cloud/add';
export const TELEMETRY_ADD_CLOUD_SENSOR_ROUTE =
  '/telemetry/cloud/add/:sensorType';
export const TELEMETRY_LOG_SOURCES_ROUTE = '/telemetry/log-sources';
export const TELEMETRY_VIEW_CLOUD_SENSORS_ROUTE =
  '/telemetry/cloud/view/:deploymentId';

export const TELEMETRY_SCAN_SCHEDULES_ROUTE = '/telemetry/scan-schedules';
export const TELEMETRY_CREATE_NEW_SCAN_SCHEDULE_ROUTE =
  '/telemetry/scan-schedules/create';
export const TELEMETRY_EDIT_SCAN_SCHEDULE_ROUTE =
  '/telemetry/scan-schedules/edit/:scheduleId';

export const RISK_MANAGEMENT_OVERVIEW_ROUTE = '/risk-management';
export const RISK_MANAGEMENT_RISKS_ROUTE = '/risk-management/risks';
export const RISK_MANAGEMENT_RISKS_ALL_ROUTE = `${RISK_MANAGEMENT_RISKS_ROUTE}/all`;
export const RISK_MANAGEMENT_RISKS_VULNERABILITIES_ROUTE = `${RISK_MANAGEMENT_RISKS_ROUTE}/vulnerabilities`;
export const RISK_MANAGEMENT_RISK_DETAILS_ROUTE = `${RISK_MANAGEMENT_RISKS_ROUTE}/:riskId/risk-details`;
export const RISK_MANAGEMENT_RISK_EVIDENCE_ROUTE = `${RISK_MANAGEMENT_RISKS_ROUTE}/:riskId/risk-evidence`;
export const RISK_MANAGEMENT_RISK_EXPOSURE_OVERVIEW_ROUTE =
  '/risk-management/risk-exposure-overview';

// THREAT_INTEL_SKU_PATH
export const THREAT_INTEL_SKU_ROUTE = '/reports/tip-sku';
export const THREAT_INTEL_SKU_BULLETINS_RELATIVE_PATH = '/threat-intelligence';
export const THREAT_INTEL_SKU_BULLETINS_PATH = `${THREAT_INTEL_SKU_ROUTE}${THREAT_INTEL_SKU_BULLETINS_RELATIVE_PATH}`;
export const THREAT_INTEL_SKU_BULLETIN_RELATIVE_PATH =
  '/threat-intelligence/:idSlug?';
export const THREAT_INTEL_SKU_BULLETIN_PATH = `${THREAT_INTEL_SKU_ROUTE}${THREAT_INTEL_SKU_BULLETIN_RELATIVE_PATH}`;

// ACCESS CONTROL ROUTES
export const ACCESS_CONTROL_ROUTE = '/access-control';
export const ACCESS_CONTROL_ACCOUNTS_ROUTE = `${ACCESS_CONTROL_ROUTE}/accounts`;
export const ACCESS_CONTROL_ROLES_ROUTE = `${ACCESS_CONTROL_ROUTE}/roles`;
export const ACCESS_CONTROL_PERMISSIONS_ROUTE = `${ACCESS_CONTROL_ROUTE}/permissions`;

//CYBER RESILIENCE ASSESSMENT ROUTES
export const CYBER_RESILIENCE_ASSESSMENT_ROUTE =
  '/security-journey/cyber-resilience-assessment';
export const CYBER_RESILIENCE_ASSESSMENT_COLLABORATORS_ROUTE =
  '/security-journey/collaborators';

export const CYBER_RESILIENCE_ASSESSMENT_RELATIVE_PATH = `${CYBER_RESILIENCE_ASSESSMENT_ROUTE}/:assessmentId`;
export const CYBER_RESILIENCE_ASSESSMENT_LIST_ROUTE = `${CYBER_RESILIENCE_ASSESSMENT_ROUTE}/list`;
export const CYBER_RESILIENCE_ASSESSMENT_NO_ASSESSMENT_ROUTE = `${CYBER_RESILIENCE_ASSESSMENT_ROUTE}/no-assessment`;
export const CYBER_RESILIENCE_ASSESSMENT_HISTORY_PATH = `${CYBER_RESILIENCE_ASSESSMENT_RELATIVE_PATH}/history`;
export const CYBER_RESILIENCE_ASSESSMENT_QUICK_START_PATH = `${CYBER_RESILIENCE_ASSESSMENT_RELATIVE_PATH}/quick-start`;
export const CYBER_RESILIENCE_ASSESSMENT_MANAGE_ASSESMENT_PATH = `${CYBER_RESILIENCE_ASSESSMENT_RELATIVE_PATH}/manage-assessment`;
export const CYBER_RESILIENCE_ASSESSMENT_GROUPS_PATH = `${CYBER_RESILIENCE_ASSESSMENT_RELATIVE_PATH}/groups/:groupId`;
export const CYBER_RESILIENCE_ASSESSMENT_PRODUCTS_PATH = `${CYBER_RESILIENCE_ASSESSMENT_RELATIVE_PATH}/products/:productId`;
export const CYBER_RESILIENCE_ASSESSMENT_INSURABILITY_PATH = `${CYBER_RESILIENCE_ASSESSMENT_RELATIVE_PATH}/insurability`;

//INCIDENT RESPONSE ROUTES
export const INCIDENT_RESPONSE_ROUTE = '/incident-response';

//CYBER RESILIENCE ASSESSMENT FILE REPOSITORY ROUTES
export const CRA_FILE_REPOSITORY_ROUTE = '/security-journey/files';
export const CRA_FILE_REPOSITORY_RELATIVE_PATH = `${CRA_FILE_REPOSITORY_ROUTE}/:assessmentId`;
